export const url = `${import.meta.env.VITE_SERVER_URL}/api`
/* the socket.io origin (src/socket.js, features/liveJudging/realtime/liveSocket.js): the API url without its /api */
export const urlSocket = url.replace('/api', '')
